import type { S3 } from '@aws-sdk/client-s3';
import * as React from 'react';

export const LegacyAnalyticsAccountS3ClientContext = React.createContext<S3 | null>(null);

/** Get the Legacy Analytics S3 client in GSOC account */
export function useLegacyAnalyticsAccountS3Client(): S3 | null {
  return React.useContext(LegacyAnalyticsAccountS3ClientContext);
}
